<template>
  <client-layout>
    <div>
      <users-list :client="client"></users-list>
    </div>
  </client-layout>
</template>

<script>
import { mapState } from 'vuex';
import ClientLayout from '@/views/settings/clients/ClientLayout.vue';
import UsersList from '@/views/settings/UsersList.vue';

export default {
  data: () => ({
  }),
  computed: {
    ...mapState(`model/client`, {
      client: `currentAdminClient`,
    }),
  },
  components: {
    ClientLayout,
    UsersList,
  },
};
</script>
